export const GET_ESG_COVERAGE_DATA = 'GET_ESG_COVERAGE_DATA';
export const GET_ESG_COVERAGE_DATA_SUCCESS = `${GET_ESG_COVERAGE_DATA}_SUCCESS`;
export const GET_ESG_COVERAGE_DATA_ERROR = `${GET_ESG_COVERAGE_DATA}_ERROR`;

export const getEsgCoverageAction = (regs) => (query) => {
  const {
    limit,
    page,
    sort,
    filter: {
      countries,
      industries,
      environmentFrom,
      environmentTo,
      socialFrom,
      socialTo,
      governanceFrom,
      governanceTo,
      totalScoreFrom,
      totalScoreTo,
    },
  } = query;

  const orderBy = {
    environmentScore: 'e_score',
    socialScore: 's_score',
    governanceScore: 'g_score',
    totalScore: 'esg_score',
    industry: 'industry__storefront_name',
    companyName: 'scope_one_company_name',
    companyCountry: 'country',
  }[sort?.sortColumn];

  return {
    type: GET_ESG_COVERAGE_DATA,
    payload: {
      limit,
      offset: (page - 1) * limit,
      industry: industries?.map(
        (filter) =>
          regs.data?.industries.find((industry) => industry.industryName === filter)?.industryCode,
      ),
      orderBy: orderBy && `${sort.direction === 'DESC' ? '-' : ''}${orderBy}`,
      country: countries,
      environmentFrom,
      environmentTo,
      socialFrom,
      socialTo,
      governanceFrom,
      governanceTo,
      totalScoreFrom,
      totalScoreTo,
    },
  };
};
